module.exports = __webpack_public_path__ + "img/icon2.0bb5c8de.png";